/**
 * useGameWiki — accède à l'entrée wiki d'un jeu depuis le namespace i18n
 * `game-wiki` (Wave M2-content).
 *
 * Slug app (`memory-matrix`) → clé JSON normalisée (`memory_matrix`) via
 * `slugToKey`. Retourne `null` si entrée inexistante (jeu pas encore wiki-isé).
 *
 * Pas de Suspense ici : i18next gère le lazy-load du namespace (cf. `lib/i18n.ts`).
 * Si namespace pas encore fetché, `t(...)` renvoie la clé brute → on détecte via
 * un check `typeof entry === 'object'` (returnObjects).
 */
import { useTranslation } from 'react-i18next';
export function slugToKey(slug) {
    return slug.replaceAll('-', '_');
}
function isWikiEntry(value) {
    if (!value || typeof value !== 'object')
        return false;
    const v = value;
    return (typeof v.title === 'string' &&
        typeof v.subtitle === 'string' &&
        typeof v.why === 'string' &&
        typeof v.trains === 'object' &&
        Array.isArray(v.sources));
}
export function useGameWiki(slug) {
    const { t, ready } = useTranslation('game-wiki');
    if (!slug || !ready)
        return null;
    const key = slugToKey(slug);
    const raw = t(key, { returnObjects: true, defaultValue: null });
    return isWikiEntry(raw) ? raw : null;
}
//# sourceMappingURL=useGameWiki.js.map